/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class BackNavigationIcon extends BaseIcon {
    getChildren = () => [
        <g fill="none" stroke={this.getColor()}>
            <path d="m5.979.346-5.285 5.5 5.285 5.5" />
            <path d="M.986 5.818h11.707" />
        </g>
    ]
    getViewBox = () => '0 0 16 16'
}
